import api from './api';

// Occassions
const getOccasions = () => api.get('/occasion/occasions/');
const getOccasion = (occasionId) => api.get(`/occasion/occasions/${occasionId}/`);
const createOccasion = (data) => api.post('/occasion/occasions/', data);
const updateOccasion = (occasionId, data) => api.put(`/occasion/occasions/${occasionId}/`, data);
const deleteOccasion = (occasionId) => api.delete(`/occasion/occasions/${occasionId}/`);

export {
    getOccasions,
    getOccasion,
    createOccasion,
    updateOccasion,
    deleteOccasion,
};
